<template>
  <div class="bf-top">
    <global-loading v-if="$store.state.vaStore.vendor_per_region_loading" />
    <div class="pointer" style="position:absolute;right:2%;top:2%;font-size:20px">
      <i class="fa-solid fa-file-arrow-down" style="color:red" @click="downloadVendorRegion()"
        v-if="$store.state.vaStore.vendor_per_region_level == 1"></i>
      <i class="fa-solid fa-circle-arrow-left" style="color:red" v-else @click="backLevel1()"></i>
    </div>
    <div class="doughnat-container">
      <pie-chart :chartData="chart[`chartData`]" :options="chart[`chartOptions`]" :styles="{ height: '100%' }"
        v-if="vendorPerRegion" />
    </div>
    <div class="region-list scroll-hidden">
      <div class="text-bold">Total Vendor Per Region</div>
      <ul v-if="$store.state.vaStore.vendor_per_region_level == 1">
        <li v-for="(item, index) in $store.state.vaStore.vendor_per_region" :key="index" class="pointer"
          :style="`list-style-type: none;font-size:.9rem`" @click="goLevel2(item)">
          <i class="fa-solid fa-square" :style="`color: ${chart.chartData.datasets[0].backgroundColor[index]}`
            "></i>
          {{
            item.type == 'negara'
              ? item.negara
              : item.provinsi
                ? item.provinsi
                : 'undefined'
          }}
        </li>
      </ul>
      <ul v-else>
        <li v-for="(item, index) in $store.state.vaStore.vendor_per_region" :key="index"
          :style="`list-style-type: none;font-size:.9rem`">
          <i class="fa-solid fa-square" :style="`color: ${chart.chartData.datasets[0].backgroundColor[index]}`
            "></i>
          {{ item.desc ? item.desc : 'undefined' }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import * as XLSX from 'sheetjs-style'
import moment from 'moment'

export default {
  components: {
    PieChart: () => import('@/components/chart/dashboard/pie-chart.vue'),
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },
  data() {
    return {
      labels: [
        'Kalimantan Timur',
        'Kalimantan Selatan',
        'Jawa Timur',
        'Tanah Bumbu',
        'Berau',
        'Sumatera Selatan',
        'Jakarta',
        'Muara Bungo',
      ],
      chart: {
        chartData: {
          labels: [
            'Kalimantan Timur',
            'Kalimantan Selatan',
            'Jawa Timur',
            'Tanah Bumbu',
            'Berau',
            'Sumatera Selatan',
            'Jakarta',
            'Muara Bungo',
          ],
          datasets: [
            {
              backgroundColor: [
                '#cc0000',
                '#ff6633',
                '#ff3333',
                '#ffcc00',
                '#ff6600',
                '#ff9900',
                '#ff9966',
                '#993300',
              ],
              data: [100, 250, 100, 175, 150, 150, 125, 100],
            },
          ],
        },

        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false,
            position: 'bottom',
            labels: {
              fontSize: 10,
              boxWidth: 12,
            },
          },
        },
      },
    }
  },
  created() {
    // this.$store.dispatch('vaStore/getVendorPerRegion')
  },
  computed: {
    vendorPerRegion() {
      let data = this.$store.state.vaStore.vendor_per_region
      if (this.$store.state.vaStore.vendor_per_region_level == 1) {
        this.convertData(data)
      } else {
        this.convertDataLevel2(data)
      }

      return true
    },
  },
  methods: {
    async backLevel1() {
      await this.$store.dispatch('vaStore/getVendorPerRegion')
    },
    async goLevel2(data) {
      await this.$store.dispatch('vaStore/getDetailVendorPerRegion', {
        type: data.type,
        id: data.type == 'negara' ? data.negara_id : data.provinsi_id,
      })
    },
    dynamicColors() {
      const randomNum = () => Math.floor(Math.random() * (235 - 52 + 1) + 52)
      return `rgb(${randomNum()}, ${randomNum()}, ${randomNum()})`
    },
    convertData(data) {
      let labels = []
      let value = []
      for (let i in data) {
        if (data[i].type == 'negara') {
          labels.push(data[i].negara)
        } else {
          labels.push(data[i].provinsi ? data[i].provinsi : 'undefined')
        }
        value.push(data[i].total_vendor)
      }

      this.chart = {
        chartData: {
          labels: labels,
          datasets: [
            {
              backgroundColor: [
                '#cc0000',
                '#ff6633',
                '#ff3333',
                '#ffcc00',
                '#ff6600',
                '#ff9900',
                '#ff9966',
                '#993300',
              ],
              data: value,
            },
          ],
        },
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false,
            position: 'bottom',
            labels: {
              fontSize: 10,
              boxWidth: 12,
            },
          },
        },
      }
    },
    convertDataLevel2(data) {
      let labels = []
      let value = []
      for (let i in data) {
        labels.push(data[i].desc ? data[i].desc : 'undefined')
        value.push(data[i].total_vendor)
      }

      this.chart = {
        chartData: {
          labels: labels,
          datasets: [
            {
              backgroundColor: [
                '#cc0000',
                '#ff6633',
                '#ff3333',
                '#ffcc00',
                '#ff6600',
                '#ff9900',
                '#ff9966',
                '#993300',
              ],
              data: value,
            },
          ],
        },
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false,
            position: 'bottom',
            labels: {
              fontSize: 10,
              boxWidth: 12,
            },
          },
        },
      }
    },
    async downloadVendorRegion() {
      let dateReport = moment().format('DDMMYY')
      let daterange = ''
      let start = this.$store.state.vaStore.start
      let end = this.$store.state.vaStore.end

      if (start && end) {
        daterange += `${start} - ${end}`
      }

      const total = await this.$store.dispatch(
        'vaStore/getVendorPerRegionExportTotal'
      )
      total.unshift({})
      const detail = await this.$store.dispatch(
        'vaStore/getVendorPerRegionExportDetail'
      )
      detail.unshift({})

      let wb = XLSX.utils.book_new()
      let sheet = ['Summary', 'Detail']

      sheet.forEach(list => {
        if (list == 'Summary') {
          let data = XLSX.utils.json_to_sheet(total)
          const title = [
            [
              `Total_Vendor_Per_Region_Summary_${dateReport}`,
              daterange,
              '',
              '',
              '',
            ],
            ['ID Negara', 'ID Provinsi', 'Negara', 'Provinsi', 'Total Vendor'],
          ]
          XLSX.utils.book_append_sheet(wb, data, list)
          XLSX.utils.sheet_add_aoa(data, title, {
            origin: 'A1',
          })
        } else {
          let data = XLSX.utils.json_to_sheet(detail)
          const title = [
            [
              `Total_Vendor_Per_Region_Detail_${dateReport}`,
              daterange,
              '',
              '',
              '',
              '',
              '',
              '',
              '',
              '',
              '',
            ],
            [
              'Nama Vendor',
              'ID Negara',
              'Negara',
              'ID Provinsi',
              'Provinsi',
              'Kota',
              'Isupplier Code',
              'BCE Code',
              'GEMS Code',
              'BKES Code',
              'Ariba Code',
            ],
          ]
          XLSX.utils.book_append_sheet(wb, data, list)
          XLSX.utils.sheet_add_aoa(data, title, {
            origin: 'A1',
          })
        }
      })
      XLSX.writeFile(wb, 'REPORT_VENDOR_PER_REGION.xlsx')
    },
  },
}
</script>
<style scoped>
.doughnat-container {
  width: 48%;
  height: 100%;
  position: relative;
}

.region-list {
  width: 50%;
  height: 100%;
  overflow-y: auto;
}
</style>
